/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable */
// @ts-nocheck
import React, { useRef } from 'react';
import Sketch from 'react-p5';
import p5Types from 'p5'; //Import this for typechecking and intellisense
import { getPerspective } from './algo';

type ComponentProps = {
  roomData: object;
  noPerspective: boolean;
  canvasRef: any;
  //Your component props
};
let img;
// let r: any = '';
let tileX = 0;
let tileY = 0;

let width = 0;
let height = 0;
let tileWidth = 0;
let tileHeight = 0;
let renderWidth = 0;
let renderHeight = 0;
let surface = {};

const Render = (props: ComponentProps) => {
  const { roomData, noPerspective, canvasRef } = props;

  width = roomData && roomData?.dimension?.width;
  height = roomData && roomData?.dimension?.height;

  tileWidth = roomData?.tileWidth;
  tileHeight = roomData?.tileHeight;

  if (!noPerspective) {
    surface = getPerspective(roomData?.dimension, roomData?.surface[0], 0);
    renderWidth = surface?.widthRound;
    renderHeight = surface?.heightRound;
  } else {
    renderWidth = width;
    renderHeight = height;
  }

  const preload = (p5: p5Types) => {
    p5.pixelDensity(p5.pixelDensity() * 2);
    img = p5.loadImage(roomData?.tile);
    // r = p5.loadImage(require('../../assets/room-scene/bathroom.png'));
  };

  const setup = (p5: p5Types, canvasParentRef: Element) => {
    p5.createCanvas(width, height, 'webgl').parent(canvasParentRef);
    // p5.orbitControl();
  };

  const draw = (p5: p5Types) => {
    p5.push();
    if (!noPerspective) {
      p5.translate(
        -width / 2 + surface?.getLeft - tileWidth / 2,
        -height / 2 + surface?.getTop - tileHeight / 2,
      );
      p5.applyMatrix(surface?.perspective?.transform);
    } else {
      // p5.pixelDensity(5.0);
      p5.translate(-width / 2 - tileWidth, -height / 2 - tileHeight);
    }

    if (roomData?.installation === 'brick') {
      while (tileX <= renderWidth) {
        tileY = 0;
        let i = 0;
        while (tileY <= renderHeight) {
          const shift = i % 2 === 0 ? tileWidth / 2 : tileWidth;
          p5.image(img, tileX + shift, tileY + tileHeight, tileWidth, tileHeight);
          p5.noFill();
          p5.noStroke();
          p5.stroke(roomData?.groutColor);
          p5.strokeWeight(roomData?.groutWidth);
          p5.rect(tileX + shift, tileY + tileHeight, tileWidth, tileHeight);
          tileY += tileHeight;
          i++;
        }
        tileX += tileWidth;
      }
    } else if (roomData?.installation === 'ashlar') {
      let i = 0;
      while (tileX <= renderWidth) {
        tileY = 0;
        while (tileY <= renderHeight) {
          const shift = i % 2 === 0 ? tileHeight / 2 : tileHeight;
          p5.image(img, tileX + tileWidth, tileY + shift, tileWidth, tileHeight);
          p5.noFill();
          p5.noStroke();
          p5.stroke(roomData?.groutColor);
          p5.strokeWeight(roomData?.groutWidth);
          p5.rect(tileX + tileWidth, tileY + shift, tileWidth, tileHeight);
          tileY += tileHeight;
        }
        tileX += tileWidth;
        i++;
      }
    } else if (roomData?.installation === 'quarterTurn') {
      for (let y = 0; y <= renderHeight; y += tileHeight) {
        for (let x = 0; x <= renderWidth; x += tileWidth) {
          // Determine the rotation angle based on tile position
          let rotation = 0;
          if ((x / tileWidth + y / tileHeight) % 2 == 0) {
            rotation = 0; // 90 degrees
          } else {
            rotation = p5.HALF_PI; // -90 degrees
          }

          // Draw the tile and rotate the image
          p5.push();
          p5.translate(x + tileWidth / 2 + tileWidth, y + tileHeight / 2 + tileHeight);
          p5.rotate(rotation);
          p5.imageMode(p5.CENTER);
          p5.image(img, 0, 0, tileWidth, tileHeight);
          p5.pop();

          p5.noFill();
          p5.noStroke();
          p5.stroke(roomData?.groutColor);
          p5.strokeWeight(roomData?.groutWidth);
          p5.rect(x + tileWidth, y + tileHeight, tileWidth, tileHeight);
        }
      }
    } else {
      while (tileX <= renderWidth) {
        tileY = 0;
        while (tileY <= renderHeight) {
          p5.image(img, tileX + tileWidth, tileY + tileHeight, tileWidth, tileHeight);
          p5.noFill();
          p5.noStroke();
          p5.stroke(roomData?.groutColor);
          p5.strokeWeight(roomData?.groutWidth);
          p5.rect(tileX + tileWidth, tileY + tileHeight, tileWidth, tileHeight);
          tileY += tileHeight;
        }
        tileX += tileWidth;
      }
    }

    tileX = 0;
    tileY = 0;
    p5.pop();

    /* Background image */
    // p5.textureMode(p5.IMAGE);
    // p5.noStroke();
    // p5.texture(r);
    // p5.plane(width, height);
  };

  return (
    <Sketch
      id="roomSceneCanvas"
      preload={preload}
      setup={setup}
      ref={canvasRef}
      //   mousePressed={mp}
      draw={draw}
    />
  );
};

export default Render;
